<template>
  <div>
    <h1>New Testimonial</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>

    <TestimonialForm
      :handle-submit="onSendForm"
      :values="item"
      :errors="violations" />

    <router-link
      :to="{ name: 'TestimonialList' }"
      class="btn btn-primary mt-3">Back to list</router-link>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import TestimonialForm from './Form';

const { mapFields } = createHelpers({
    getterType: 'testimonial/create/getField',
    mutationType: 'testimonial/create/updateField',
});

export default {
  components: {
    TestimonialForm,
  },

  data () {
    return {
      item: {},
    };
  },

  computed: {
    ...mapFields([
      'error',
      'isLoading',
      'created',
      'violations',
    ]),
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return;
      }

      this.$router.push({ name: 'TestimonialList', params: { id: created['@id'] } });
    }
  },

  methods: {
    ...mapActions('testimonial/create', [
      'create',
    ]),

    onSendForm () {
      this.create(this.item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/testimonial/Create.vue